import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const StartupIndiaInitiatives = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(prev => !prev);

  return (
    <div className="practice-page">
            <ScrollToTop/>
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>

      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li key={index} className={category === "Start-up India Initiatives" ? "active" : ""}>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>

      <main className="conten">
        <h2>Start-up India Initiatives</h2>
        <p className="intro">
          InduratnaLaw supports innovation and entrepreneurship with our Start-up India Initiatives. We provide legal guidance
          and strategic support to startups at every stage, ensuring they have the robust legal framework to launch and scale successfully.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            We specialize in helping early-stage ventures navigate the challenges of incorporation, funding, intellectual property,
            and regulatory compliance. Our hands-on approach makes us a trusted partner for startups looking to establish a strong foundation.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Start-up Formation and Incorporation</li>
            <li>Intellectual Property and Patent Filing</li>
            <li>Venture Capital and Funding Advisory</li>
            <li>Contract Negotiation and Drafting</li>
            <li>Regulatory and Compliance Support</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            With a deep commitment to fostering innovation, we empower startups with the legal insights and frameworks necessary
            to succeed in a competitive marketplace.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default StartupIndiaInitiatives;
